/**
 * Представление номера телефона — ОДНОЙ конструкцией на весь модуль.
 *
 * Раньше форматирование жило двумя копиями (окно разговора и карточка звонка),
 * и копии уже разошлись: одна на нераспознанном номере отдавала пустую строку,
 * другая — исходную. Один и тот же номер выглядел в двух местах по-разному,
 * а правило проекта требует обратного: одно имя — одна конструкция.
 */
export function formatPhone(raw: string): string {
  const digits = (raw ?? '').replace(/\D+/g, '');

  if (digits.length === 11) {
    return `+${digits[0]} ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9)}`;
  }

  return (raw ?? '').trim() || digits;
}

/**
 * Маска краями для номера, известного ЛОКАЛЬНО (`zhur1`): ручной набор и
 * секунды до прихода серверного состояния. Та же формула, что у серверной
 * `Phone::maskPartial` — два вида одной маски разъехались бы.
 * Сырьё не возвращается и на неразбираемом номере.
 */
export function maskPartialLocal(raw: string | null | undefined): string {
  const digits = (raw ?? '').replace(/\D+/g, '');

  if (digits.length === 11 && digits[0] === '7') {
    return `+7 (${digits.slice(1, 4)}) ···-··-${digits.slice(9)}`;
  }

  if (digits.length === 0) return '';
  if (digits.length < 8) return '···';

  return `${digits.slice(0, 3)}···${digits.slice(-2)}`;
}
